import { useSelector } from "react-redux";

const OnboardingSidebar = ({ steps, currentStep, setCurrentStep,shareholderType }) => {
const stepStatus = useSelector((state) =>
  shareholderType
    ? state.form.stepStatusShareholder
    : state.form.stepStatus
);

  return (
    <aside className="w-full md:w-[18vw] font-medium px-4">
      {steps.map((step) => {
        let stepClass =
          "px-4 py-4 mb-2 rounded-xl text-sm flex items-center space-x-2 cursor-pointer ";

        if (step.id === currentStep) {
          stepClass += "bg-black text-white";
        } else if (
          step.id < currentStep &&stepStatus[step.id - 1]&&
          stepStatus[step.id - 1].status != "REJECTED" &&
          stepStatus[step.id - 1].status != "APPROVED"
        ) {
          stepClass += "bg-[#005A9C] text-white"; // ✅ Completed step
        } else if (stepStatus[step.id - 1]&&stepStatus[step.id - 1].status == "REJECTED") {
          stepClass += "bg-[#DC2626] text-white"; // ✅ Completed step
        } else if (stepStatus[step.id - 1]&&stepStatus[step.id - 1].status == "APPROVED") {
          stepClass += "bg-[#16A34A] text-white"; // ✅ Completed step
        } else {
          stepClass += "text-black cursor-default"; // 🚫 Future step
        }

        const isClickable = step.id < currentStep; // only previous steps

        return (
          <div
            key={step.id}
            className={stepClass}
            onClick={() => {
              if (isClickable) {
                setCurrentStep(step.id);
              }
            }}
          >
            <span className="text-xs w-5 h-5 flex items-center justify-center text-sm">
              {step.id < currentStep ? (
                <img
                  src="/tick-circle-white.svg"
                  alt="Tick"
                  className="w-5 h-5"
                />
              ) : (
                step.id.toString().padStart(2, "0") + "."
              )}
            </span>
            <span>{step.title}</span>
          </div>
        );
      })}
    </aside>
  );
};

export default OnboardingSidebar;
